import { createSlice } from "@reduxjs/toolkit";

const initialState = () => {
  const savedState = JSON.parse(localStorage.getItem("source"));
  return savedState || { source: ["IBD", "Amazon", "Kiddiewings"] };
};

const sourceState = createSlice({
  name: "SourceState",
  initialState: initialState(),
  reducers: {
    addSource(state, action) {
      if (action.payload) {
        state.source.push(action.payload);
        localStorage.setItem("source", JSON.stringify(state));
      }
    },
  },
});

export const { addSource } = sourceState.actions;
export const sourceReducer = sourceState.reducer;
